import React from 'react'
import { Link } from 'react-router-dom';
import HomeServices from '../home/HomeServices';


const Services = () => {
    return (
        <>
            <div className="page-header dark-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            {/* Page Header Box Start */}
                            <div className="page-header-box">
                                <h1 className="text-anime-style-3" data-cursor="-opaque" aria-label="Contact us" style={{ perspective: 400 }}>
                                    <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'center' }}>
                                        <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block' }}>
                                            All Services
                                        </div>
                                    </div>
                                </h1>
                                <nav className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">All Services</li>
                                    </ol>
                                </nav>
                            </div>
                            {/* Page Header Box End */}
                        </div>
                    </div>
                </div>
            </div>
            <HomeServices />


        </>
    )
}

export default Services
